<template>
  <div class="container">
    <div class="lg:flex p-4 items-start">
      <search :class="stickyClass" />
      <card class="mt-4 lg:mt-0" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, onBeforeUnmount } from "vue";
import card from "../../../views/hotel/card.vue";
import search from "../../../views/listingSearch/search.vue";
import { useSearchStore } from "../../../stores/search.module";
import { useComponentChangeStore } from "../../../stores/componentChange.module";

const searchStore = useSearchStore();
const screenWidth = ref(window.innerWidth);
const componentChangeStore = useComponentChangeStore();
const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(() => {

  window.addEventListener("resize", updateScreenWidth); 
  updateScreenWidth(); 

  let searchedData = searchStore.getsearchedHotelName
    ? { searchHotelName: searchStore.getsearchedHotelName }
    : null;

  // Step 2: If not found in the store, check localStorage
  if (!searchedData) {
    const storedData = localStorage.getItem("searchedData");
    searchedData = storedData ? JSON.parse(storedData) : null;
  }

  if (searchedData) {
    searchStore.search({ ...searchedData });
  } else {
    searchStore.search();
  }
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", updateScreenWidth);
});

const stickyClass = computed(() => (screenWidth.value > 1024 ? "sticky-search" : ""));
</script>

<style scoped>
.sticky-search {
  position: sticky;
  top: 0;
}
</style>